import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";

export interface TitleProps {
  title: string;
  subTitle?: string;
  id?: string;          // anchor id
  tocLabel?: string;    // optional TOC label override
}

const Title = (props: TitleProps) => {
  const { title, subTitle, id } = props;

  return (
    <MDBox id={id} mb={2} sx={{ scrollMarginTop: "96px" }}>
      <MDTypography variant="h4" fontWeight="bold">
        {title}
      </MDTypography>

      {subTitle && (
        <MDTypography
          variant="body2"
          sx={{
            lineHeight: "1.3",
            display: "block",
            whiteSpace: "normal",
          }}
        >
          {subTitle}
        </MDTypography>
      )}
    </MDBox>
  );
};

export default Title;
